import { Shield, Award, BadgePercent } from "lucide-react";
import ContactFormPlaceholder from "./ContactFormPlaceholder";

const HeroSection = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center pt-24 bg-gradient-to-br from-secondary via-secondary to-charcoal-dark overflow-hidden">
      {/* Background Image - static path for preload discoverability */}
      <img
        src="/hero-powerwash.webp"
        alt=""
        role="presentation"
        fetchPriority="high"
        loading="eager"
        width={1920}
        height={1080}
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover object-[center_30%] opacity-30 md:opacity-30 max-md:opacity-50"
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-secondary/95 via-secondary/80 to-transparent md:from-secondary/95 max-md:from-secondary/80 max-md:via-secondary/60" />

      <div className="container-custom relative z-10">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          {/* Left Content - 60% */}
          <div className="lg:col-span-3 text-white">
            <div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-heading leading-tight mb-6">
                PRESSURE WASHING IN{" "}
                <span className="text-primary">MARTINSBURG, WV</span>{" "}
                & THE EASTERN PANHANDLE
              </h1>
              
              <p className="text-xl md:text-2xl text-gray-300 mb-4">
                Residential & Commercial Properties in MD, WV & VA
              </p>
              
              <p className="text-lg text-gray-400 mb-8 max-w-2xl">
                Stream Masters Power Washing delivers professional pressure washing in Martinsburg, WV 
                and throughout the Eastern Panhandle. Veteran-owned and operated by firemen, we serve 
                residential and commercial properties across West Virginia, Virginia, and Maryland. 
                Call today for a free estimate — we're ready to transform your property.
              </p>

              {/* Trust Badges */}
              <div className="flex flex-wrap gap-4">
                <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg">
                  <Award className="w-5 h-5 text-primary" />
                  <span className="text-sm font-medium">Veteran Owned & Operated</span>
                </div>
                <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg">
                  <Shield className="w-5 h-5 text-primary" />
                  <span className="text-sm font-medium">Licensed & Insured</span>
                </div>
                <div className="flex items-center gap-2 bg-primary/20 backdrop-blur-sm px-4 py-2 rounded-lg border border-primary/30">
                  <BadgePercent className="w-5 h-5 text-primary" />
                  <span className="text-sm font-medium">10% Discount for First Responders & Military</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content - Contact Form Card - 40% */}
          <div className="lg:col-span-2">
            <ContactFormPlaceholder />
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent" />
    </section>
  );
};

export default HeroSection;
